import React, { ReactNode } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  onBack?: () => void;
  backLabel?: string;
  action?: ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  onBack,
  backLabel = 'Nazaj',
  action
}: PageHeaderProps) {
  return <header className="mb-5" data-id="element-1274" data-mp="psvzey61o9m8">
      {onBack && <button type="button" onClick={onBack} className="-ml-2 mb-2 inline-flex h-9 items-center gap-1.5 rounded-xl px-2 text-sm font-bold text-muted transition-colors duration-150 hover:bg-surface hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent" data-id="element-1275" data-mp="ttfyi7a6hnb0">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1276" data-mp="18ilulmdpyxeo" /> {backLabel}
        </button>}
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-1277" data-mp="1di8a62h0spqn">
        <div className="min-w-0" data-id="element-1278" data-mp="1hj0kkz1mp0oi">
          <h1 className="font-display text-3xl font-semibold leading-tight md:text-4xl" data-id="element-1279" data-mp="1hk27c0s0bbm2">{title}</h1>
          {subtitle && <div className="mt-1 text-sm text-muted" data-id="element-1280" data-mp="f1axav0dxzq1">{subtitle}</div>}
        </div>
        {action}
      </div>
    </header>;
}